module.exports = __webpack_public_path__ + "static/media/in_the_bag.6148e73a.png";